var __templateData = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, buffer = "<div class=\"information\">"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "header", {"name":"i18n","hash":{},"data":data})))
    + "</div>\n<table class=\"standard-table questions\">\n  <thead>\n    <tr>\n      <th>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "question", {"name":"i18n","hash":{},"data":data})))
    + "</th>\n      <th>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "rating", {"name":"i18n","hash":{},"data":data})))
    + "</th>\n      <th class=\"with-info\">\n        <span class=\"info-sign\" title=\""
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "accepted_help", {"name":"i18n","hash":{},"data":data})))
    + "\"></span>\n        "
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "accepted", {"name":"i18n","hash":{},"data":data})))
    + "\n      </th>\n      <th class=\"with-info\">\n        <span class=\"info-sign\" title=\""
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "mentioned_help", {"name":"i18n","hash":{},"data":data})))
    + "\"></span>\n        "
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "mentioned", {"name":"i18n","hash":{},"data":data})))
    + "\n      </th>\n      <th class=\"with-info\" title=\""
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "rejected_help", {"name":"i18n","hash":{},"data":data})))
    + "\">\n        <span class=\"info-sign\" title=\""
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "rejected_help", {"name":"i18n","hash":{},"data":data})))
    + "\"></span>\n        "
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "rejected", {"name":"i18n","hash":{},"data":data})))
    + "\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n  </tbody>\n</table>\n";
  stack1 = helpers.unless.call(depth0, (depth0 != null ? depth0.preview : depth0), {"name":"unless","hash":{},"fn":this.program(2, data),"inverse":this.noop,"data":data});
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"2":function(depth0,helpers,partials,data) {
  return "  <div class=\"bottom-bar row mt-20\"></div>\n";
  },"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.i18nNamespace || (depth0 && depth0.i18nNamespace) || helperMissing).call(depth0, "scope:questions.proposal", {"name":"i18nNamespace","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}